import { render } from "./AddNews.vue?vue&type=template&id=4839f7ae&scoped=true"
import script from "./AddNews.vue?vue&type=script&lang=js"
export * from "./AddNews.vue?vue&type=script&lang=js"

import "./AddNews.vue?vue&type=style&index=0&id=4839f7ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4839f7ae"]])

export default __exports__